var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWomanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 67.212,
    viewBox: "0 0 68 67.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WOMAN",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1737",
    "data-name": "Rectangle 1737",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#132320",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 63.212,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 66,
    height: 65.212,
    rx: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_049-woman",
    "data-name": "049-woman",
    d: "M115.23,52.643a10.566,10.566,0,0,0-3.436-7.468V16.515C111.793,7.408,104.985,0,96.618,0S81.444,7.408,81.444,16.515v21.7a16.553,16.553,0,0,0,1.148,6.072A10.615,10.615,0,0,0,78,53.14v5.912a.923.923,0,1,0,1.839,0v-.922a14.739,14.739,0,0,0,11.939-4.879c6.866,3.255,14.937,5.041,21.628,1.288v4.512a.923.923,0,1,0,1.839,0c0-5.707.006-6.283-.012-6.409Zm-35.4,3.484V53.14a8.576,8.576,0,0,1,3.595-7.061,14.666,14.666,0,0,0,6.546,6.276A12.98,12.98,0,0,1,79.834,56.127ZM90.18,50.24a13.6,13.6,0,0,1-6.9-12.022v-21.7C83.283,8.512,89.265,2,96.618,2s13.335,6.51,13.335,14.513V43.877a8.8,8.8,0,0,0-4.2-1.067,1,1,0,0,0,0,2,7.185,7.185,0,0,1,4.527,1.614.925.925,0,0,0,.1.081,8.448,8.448,0,0,1,2.984,5.764C106.4,56.842,97.51,54.108,90.18,50.24Zm18.739-23.875V22.154c0-5.735-4.033-10.5-9.272-11a31.808,31.808,0,0,0-6.057,0,10.529,10.529,0,0,0-9.107,9.018c-.211,1.163-.165,1.918-.165,6.193,0,7.157,5.41,13.311,12.3,13.311S108.919,33.523,108.919,26.365Zm-12.3,11.309c-5.768,0-10.461-5.107-10.461-11.385,0-4.508-.018-4.468.056-5.174a30.2,30.2,0,0,1,17.168-1.079.924.924,0,0,0,1.09-.773,1,1,0,0,0-.71-1.186,31.864,31.864,0,0,0-17.034.762,8.393,8.393,0,0,1,7.024-5.69,30.261,30.261,0,0,1,5.735,0c4.329.414,7.594,4.286,7.594,9.005v4.135C107.079,32.567,102.386,37.674,96.618,37.674Z",
    transform: "translate(-63.201 3.946)",
    fill: "#132320"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanIcon);
export default __webpack_public_path__ + "static/media/woman-icon.e08ee218.svg";
export { ForwardRef as ReactComponent };